module.exports = __webpack_public_path__ + "img/fish-curry.22364d56.jpg";